<template>
  <CadastroBase
    nomePlural="ModeloDocumentacaoAcessorias"
    nomeSingular="ModeloDocumentacaoAcessoria"
    @submitSuccessInsert="emitSubmitSuccess"
    @submitErrorInsert="emitSubmitError"
    @closeModalInsert="closeModal"
  >
    <v-col cols="12">
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="recurso.descricao"
            :label="$t('Descricao')"
            name="descricao"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-text-field>
        </v-col>

        <v-col cols="12" md="6">
          <v-checkbox v-model="recurso.impressaoComCabecalho">
            <template v-slot:label>
              {{ $t("impressaoComCabecalho") }}
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="12" md="6">
          <v-checkbox v-model="recurso.impressaoSemCabecalho">
            <template v-slot:label>
              {{ $t("impressaoSemCabecalho") }}
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12" md="4">
          <v-checkbox
            v-model="recurso.geracaoAutomaticaAdmissaoPrazoIndeterminado"
          >
            <template v-slot:label>
              {{ $t("geracaoAutomaticaAdmissaoPrazoIndeterminado") }}
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12" md="4">
          <v-checkbox
            v-model="recurso.geracaoAutomaticaAdmissaoPrazoDeterminado"
          >
            <template v-slot:label>
              {{ $t("geracaoAutomaticaAdmissaoPrazoDeterminado") }}
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12" md="4">
          <v-checkbox v-model="recurso.geracaoAutomaticaAdmissaoIntermitente">
            <template v-slot:label>
              {{ $t("geracaoAutomaticaAdmissaoIntermitente") }}
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12" md="4">
          <v-checkbox v-model="recurso.geracaoAutomaticaAvisoPrevioIndenizado">
            <template v-slot:label>
              {{ $t("geracaoAutomaticaAvisoPrevioIndenizado") }}
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="12" md="4">
          <v-checkbox v-model="recurso.geracaoAutomaticaAvisoPrevioTrabalhado">
            <template v-slot:label>
              {{ $t("geracaoAutomaticaAvisoPrevioTrabalhado") }}
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="12" md="4">
          <v-checkbox v-model="recurso.geracaoAutomaticaFerias">
            <template v-slot:label>
              {{ $t("geracaoAutomaticaFerias") }}
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="12" md="4">
          <v-checkbox v-model="recurso.geracaoAutomaticaFeriasAbono">
            <template v-slot:label>
              {{ $t("geracaoAutomaticaFeriasAbono") }}
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12" md="4">
          <v-checkbox v-model="recurso.geracaoAutomaticaSuspensao">
            <template v-slot:label>
              {{ $t("geracaoAutomaticaSuspensao") }}
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="12" md="4">
          <v-checkbox v-model="recurso.geracaoAutomaticaAdvertencia">
            <template v-slot:label>
              {{ $t("geracaoAutomaticaAdvertencia") }}
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="12" md="4">
          <v-checkbox
            v-model="recurso.geracaoAutomaticaMovimentacaoPostoTrabalho"
          >
            <template v-slot:label>
              {{ $t("geracaoAutomaticaMovimentacaoPostoTrabalho") }}
            </template>
          </v-checkbox>
        </v-col>
        <v-col cols="12" md="4">
          <v-checkbox v-model="recurso.geracaoRomaneioUniforme">
            <template v-slot:label>
              {{ $t("geracaoRomaneioUniforme") }}
            </template>
          </v-checkbox>
        </v-col>

        <v-col cols="12" md="12">
          <AjudaVariaveisTexto :definicao="variaveisTexto" />
          <v-textarea
            v-model="recurso.texto"
            :label="$t('Texto')"
            :payload="recurso.texto"
            class="
              input-style
              font-size-input
              text-light-input
              placeholder-light
              input-icon
            "
            dense
            flat
            filled
            solo
          >
          </v-textarea>
        </v-col>
      </v-row>
    </v-col>
  </CadastroBase>
</template>

<script>
import CadastroBase from "@/components/base/Crud/CadastroBase";
import AjudaVariaveisTexto from "@/components/base/proprios/AjudaVariaveisTexto";
import variaveisTexto from "./variaveisModeloDocumentacaoAcessoria";

import ModeloDocumentacaoAcessoriaDataService from "@/services/pessoal/ModeloDocumentacaoAcessoriaDataService";
const DataService = ModeloDocumentacaoAcessoriaDataService;

import createNumberMask from "text-mask-addons/dist/createNumberMask";
const currencyMask = createNumberMask({
  prefix: "R$",
  allowDecimal: true,
  includeThousandsSeparator: true,
  allowNegative: false,
});

export default {
  components: { CadastroBase, AjudaVariaveisTexto },
  name: "CadastroModeloDocumentacaoAcessoria",

  data() {
    return {
      DataService: DataService,

      submited: false,
      mask: currencyMask,

      recurso: {
        descricao: "",
        salarioBase: "",
        geracaoRomaneioUniforme: false,
      },

      errors: [],
      variaveisTexto,
    };
  },
  methods: {
    emitSubmitSuccess() {
      this.$emit("submitSuccessInsert");
    },
    emitSubmitError() {
      this.$emit("submitErrorInsert");
    },
    closeModal() {
      this.$emit("closeModalInsert");
    },
  },
};
</script>

<style scoped>
#app .INATIVO {
  color: red;
}
</style>
